import type { CalibrationStatus } from '../calibrationTypes'

type CalibrationProgressProfile = {
  calibration_status?: CalibrationStatus | null
  calibration_completed_sessions?: number | null
}

/** Defensive count for UI — dirty not_started rows must read as 0. */
export function safeCalibrationSessionCount(profile: CalibrationProgressProfile): number {
  const raw = profile.calibration_completed_sessions ?? 0

  if (profile.calibration_status === 'not_started') {
    return 0
  }

  if (profile.calibration_status === 'completed') {
    return 4
  }

  return Math.max(0, Math.min(4, raw))
}
